import { DIRECTOR_LIFECYCLE, type DirectorLifecycleResult } from '@league/shared/league-lifecycle';
import { StatusChip } from '@league/ui';

export function DirectorLifecycleBadge({ lifecycle, leagueStatus }: { lifecycle: DirectorLifecycleResult; leagueStatus?: string }) {
  return lifecycle.state === null ? (
    <span className="text-[13px] text-ink-3">All sessions voided</span>
  ) : (
    <StatusChip status={leagueStatus !== undefined && lifecycle.state === 'rostering' ? { ...DIRECTOR_LIFECYCLE.rostering, label: leagueStatus === 'draft' ? 'Draft' : 'Building your roster' } : DIRECTOR_LIFECYCLE[lifecycle.state]} />
  );
}
